import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guard/auth.guard";
import { BaseComponent } from "./base/base.component";

const routes: Routes = [
  {
    path: "",
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      
      {
        path: "dashboard",
        loadChildren: () =>
          import("./../../views/pages/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
      },
      { path: "", redirectTo: "balance", pathMatch: "full" },
      {
        path: 'balance',
         loadChildren: () => import('./../../views/pages/master/balance/balance.module').then(m => m.BalanceModule)
      },
      {
        path: 'blockcard',
         loadChildren: () => import('./../../views/pages/master/blockcard/blockcard.module').then(m => m.BlockcardModule)
      },
      
      {
        path: 'transaction',
         loadChildren: () => import('./../../views/pages/master/transaction/transaction.module').then(m => m.TransactionModule)
      },
      {
        path: 'smssetup',
         loadChildren: () => import('./../../views/pages/master/smssetup/smssetup.module').then(m => m.SmssetupModule)
      },
      {
        path: 'statements',
         loadChildren: () => import('./../../views/pages/master/statements/statements.module').then(m => m.StatementsModule)
      },
      {
        path: 'walletstatement',
         loadChildren: () => import('./../../views/pages/master/walletstatement/walletstatement.module').then(m => m.WalletstatementModule)
      },
      {
        path: 'wallettransfer',
         loadChildren: () => import('./../../views/pages/master/wallettransfer/wallettransfer.module').then(m => m.WallettransferModule)
      },
      
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LayoutRoutingModule { }
